import { render, staticRenderFns } from "./PermissionDenied.vue?vue&type=template&id=63872c51&scoped=true&"
import script from "./PermissionDenied.vue?vue&type=script&lang=js&"
export * from "./PermissionDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63872c51",
  null
  
)

export default component.exports